import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/descuentos-tipos-de-nominas-empleados';

/**
 * GET Descuentos Tipos de Nominas Empleados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDescuentosTiposDeNominasEmpleados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Descuento Tipo de Nomina Empleado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getDescuentoTipoDeNominaEmpleado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Descuento Tipo de Nomina Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDescuentoTipoDeNominaEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Descuento Tipo de Nomina Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDescuentoTipoDeNominaEmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Descuento Tipo de Nomina Empleado
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteDescuentoTipoDeNominaEmpleado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
